import { render } from "./allergensComponent.vue?vue&type=template&id=408057f8"
import script from "./allergensComponent.vue?vue&type=script&lang=js"
export * from "./allergensComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\fronted-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__